/**
 * Contentful metadata tag ids for blog Page queries (legacy + taxonomy).
 */

/** Page entries tagged as blog articles may use any of these metadata tag ids. */
export const PAGE_BLOG_METADATA_TAG_IDS = ['pageBlog', 'page:Blog', 'page:blog'];

/**
 * Normalize a category display label to the kebab term used in blog filter URLs
 * and legacy Contentful tag ids (strip non-alphanumeric except spaces/hyphens, preserve case).
 *
 * @param {string} displayName - e.g. `News & Events`, `The KING Difference`
 * @returns {string} e.g. `News-Events`, `The-KING-Difference`
 */
export function categoryTagTermFromDisplayName(displayName) {
  return String(displayName)
    .replace(/[^a-zA-Z0-9\s-]/g, '')
    .replace(/\s+/g, '-');
}

/**
 * Build category metadata tag ids for GraphQL `id_contains_some` from editor-facing labels
 * or from values already in `category:…` / legacy `categoryKebab` form (BlogListing, Search idle).
 *
 * Display labels are normalized for legacy ids: strip non-alphanumeric except spaces/hyphens,
 * collapse spaces to `-`, preserve case (e.g. `News & Events` → `categoryNews-Events`).
 *
 * @param {string[]} terms - e.g. `['Design Inspiration']`, `['category:Design Inspiration']`, `['Living']`
 * @returns {string[]}
 */
export function categoryTagIdsFromTerms(terms) {
  const set = new Set();

  for (const raw of terms) {
    const displayName = String(raw || '').trim();

    if (!displayName) {
      continue;
    }

    if (displayName.toLowerCase().startsWith('category:')) {
      set.add(displayName);
      set.add(displayName.toLowerCase());
      continue;
    }

    const kebabCase = categoryTagTermFromDisplayName(displayName);

    // Legacy (no colon), e.g. categoryDesign-Inspiration
    set.add(`category${kebabCase}`);
    set.add(`category${kebabCase.toLowerCase()}`);

    // Taxonomy style from Contentful Tags UI, e.g. category:Dining, category:Design Inspiration
    set.add(`category:${displayName}`);
    set.add(`category:${displayName.toLowerCase()}`);
    set.add(`category:${kebabCase}`);
    set.add(`category:${kebabCase.toLowerCase()}`);
  }

  return [...set];
}
